export const avatarSizes = {
  lg: 48,
  md: 40,
  sm: 32,
} as const;

export type AvatarSize = keyof typeof avatarSizes;
